import { render, staticRenderFns } from "./NewPaymentMethod.vue?vue&type=template&id=3b12577e&scoped=true&"
import script from "./NewPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./NewPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./NewPaymentMethod.vue?vue&type=style&index=0&id=3b12577e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b12577e",
  null
  
)

export default component.exports